import { Component } from "react";
import JWTTokenService from "../core_library/authentication/jwt_token_service";
import AuthWebService from "../service/auth_web_service";
import Cookies from 'js-cookie';

class AuthBloc extends Component {
  static resetAuthData(){    
    sessionStorage.clear();
    sessionStorage.removeItem("isAuthenticate");
    sessionStorage.removeItem("authenticateToken");
    sessionStorage.removeItem("isLogin");
    sessionStorage.removeItem("dataUser");
    sessionStorage.removeItem("selectedBank");
    sessionStorage.removeItem("userSettings");
    Cookies.remove("auth0.XQyHjGG5TBhD3n8qerFR29ojfC1lMFtP.is.authenticated")    
  }
  static isHeadOfBanca(id) {
    return id == "FWD_HEAD_OF_BANCA" ? true : false;
  }

  static isSalePerson(mapCode) {
    return mapCode == "SalesP" ? true : false;
  }

  static async getAuthAccessToken(){
    let response = await AuthWebService.getAuthAccessToken();

    if (response.success) {      
    }

    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

    static async login(token,idToken) {
    let response = await AuthWebService.login(
      token,
      idToken    
    );

    if (response.success) {
      sessionStorage.setItem("dataUser", JSON.stringify(response.data));
    }

    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  static async resetPassword(userName, password) {
    let response = await AuthWebService.resetPassword(userName, password);

    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  static async changePassword(userName, oldPassword, password) {
    let response = await AuthWebService.changePassword(
      userName,
      oldPassword,
      password
    );

    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  static async logOutPortal() {
    let response = await AuthWebService.logOutPortal();
    if (response.success == true) {
      sessionStorage.removeItem("dataUser");
      sessionStorage.removeItem("selectedBank");
      sessionStorage.removeItem("userSettings");     
    }
    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  static getDataUser() {
    return sessionStorage.getItem("dataUser")
      ? JSON.parse(sessionStorage.getItem("dataUser"))
      : null;
  }

  static setGodMode(value) {
    sessionStorage.setItem("godMode", value);
  }

  static getGodMode() {
    return sessionStorage.getItem("godMode");
  }

  static async currentAccessToken() {
    let token = "";
    let refreshToken = "";

    let dataUser = JSON.parse(sessionStorage.getItem("dataUser"));
    if (dataUser) {
      token = dataUser.accessToken;
      refreshToken = dataUser.refreshToken;
    }

    return token;
  }

  static async checkSession() {
    let token = "";
    let refreshToken = "";

    let dataUser = JSON.parse(sessionStorage.getItem("dataUser"));
    if (dataUser) {
      token = dataUser.accessToken;
      refreshToken = dataUser.refreshToken;
    }

    if (token) {
      // Check Expirity of the token
      let isTokenValid = await JWTTokenService.isValid(token);

      if (!isTokenValid) {
        /* // Do Renew Token
        let resp = await AuthWebService.renewToken(refreshToken);

        //console.log(resp);

        if (resp.success) {
          sessionStorage.setItem("dataUser", JSON.stringify(resp.data));
          dataUser = JSON.parse(sessionStorage.getItem("dataUser"));
        } else {
          sessionStorage.removeItem("dataUser");
          dataUser = "";
        } */
       dataUser = ""
      }
    }
    return dataUser;
  }
}
export default AuthBloc;
